import PropTypes from 'prop-types'
import React from 'react'
import styles from './nav.module.scss'
import SubLevel from 'components/Nav/subcomponents/SubLevel'
import clsx from 'clsx'

const Nav = ({ items = [], level = 1, collapse = false, className }) => {
  return (
    <div
      className={clsx(
        styles['nav'],
        collapse ? styles['nav_collapsed'] : styles['nav_expanded'],
        className,
      )}
    >
      <nav className={styles['nav__list']}>
        {items.map((props, index) => {
          //eslint-disable-next-line
          const { label_key, label, key } = props
          if (!label_key && !label) return

          return (
            // eslint-disable-next-line react/jsx-key
            <SubLevel
              {...props}
              level={level}
              routeKey={key}
              collapse={collapse}
              isFirst={index === 0}
            />
          )
        })}
      </nav>
    </div>
  )
}

Nav.propTypes = {
  className: PropTypes.string,
  collapse: PropTypes.bool,
  items: PropTypes.array,
  simple: PropTypes.bool,
  open: PropTypes.bool,
  level: PropTypes.number,
}

export default Nav
